// extracted by mini-css-extract-plugin
export default {"popover":"_2_uTj"};